<template>
    <v-form-element :id="id" :label="label" :form="form" :input-name="inputName" :with-counter="withCounter" :max-length="maxLength" :container-class-name="containerClassName" :label-container-class-name="labelContainerClassName" :input-container-class-name="inputContainerClassName" :helper="helper">
        <vue-google-autocomplete
            ref="autocomplete"
            :id="id"
            :classname="className"
            :placeholder="getPlaceholder()"
            :value="model.display"
            :country="country"
            :enable-geolocation="enableGeolocation"
            @placechanged="getAddressData"
            @keydown.native.enter.prevent
            @keyup="locationChanged"
            :types="types"
            v-if="google"
        >
        </vue-google-autocomplete>
    </v-form-element>
</template>

<script>

    import Vue from 'vue';
    import {mapState} from 'vuex';
    import VueGoogleAutocomplete from 'vue-google-autocomplete';
    import FormElement from './Element';
    import mixin from './mixin';

    export default {
        components: {
            'v-form-element': FormElement,
            'vue-google-autocomplete': VueGoogleAutocomplete
        },
        mixins: [mixin],
        props: {
            enableGeolocation: {
                type: Boolean,
                default: true
            },
            country: {
                default: ['be', 'fr', 'nl', 'lu', 'de', 'gb']
            },
            types: {
                type: String,
                default: 'address'
            }
        },
        data() {
            return {
                data: {
                    googleAutocompleteId: null
                }
            }
        },
        computed: {
            ...mapState(['google'])
        },
        methods: {

            /**
             * Event when a city is selected from the Google autocomplete field
             */
            getAddressData(data) {
                this.$store.dispatch('formatLocation', {address: data})
                    .then(address => {
                        this.setAddress(address);
                        this.$emit('address-changed', this.model);
                        this.$emit('address-selected', this.model);
                    });
            },

            /**
             * Event triggered when the google autocomplete field's value is changed.
             */
            locationChanged(event)
            {
                if ( ! this.model.display || this.$refs.autocomplete.autocompleteText.trim() !== this.model.display.trim() ) {
                    this.resetAddress();
                }
                this.model.display = this.$refs.autocomplete.autocompleteText;
                this.$emit('address-changed', this.model);
            },

            /**
             * Set the data of the address.
             */
            setAddress(address)
            {
                this.model = address;
                this.model.display = this.$refs.autocomplete.autocompleteText;
            },

            /**
             * Reset the address object to an empty object.
             */
            resetAddress()
            {
                this.model = {
                    street_name: null,
                    street_number: null,
                    postal_code: null,
                    city: null,
                    latitude: null,
                    longitude: null
                };
            }
            
        },

        created() {
            if ( typeof this.model === 'object' ) {
                this.model = this.model;
            }
        },

        mounted() {
            this.$store.dispatch('loadGoogleMaps')
                .then(() => {
                    Vue.nextTick(() => {
                        if ( this.$refs.autocomplete ) {
                            var input = this.$refs.autocomplete.$el;
                            input.setAttribute('type', 'search');
                        }
                    });
                });
        }
    }
</script>